var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import { dealerApiMiddleware, dealerApiReducer } from './apis/dealerApi';
import { hondaRestApiMiddleware, hondaRestApiReducer } from './apis/hondaRestApi';
import { inventoryApiMiddleware, inventoryApiReducer } from './apis/inventoryApi';
import { publicationsApiMiddleware, publicationsApiReducer } from './apis/publicationsApi';
import { layoutServiceApiMiddleware, layoutServiceApiReducer } from './apis/layoutServiceApi';
export var rootReducer = combineReducers(__assign(__assign({}, reducers), { hondaRestApi: hondaRestApiReducer, inventoryApi: inventoryApiReducer, dealerApi: dealerApiReducer, publicationsApi: publicationsApiReducer, layoutServiceApi: layoutServiceApiReducer }));
var rootStateMiddleware = (function (store) { return function (next) { return function (action) {
    var _a;
    var rootState = store.getState();
    var reduxAction = action;
    var enhancedAction = __assign(__assign({}, reduxAction), { meta: __assign(__assign({}, ((_a = reduxAction.meta) !== null && _a !== void 0 ? _a : {})), { rootState: rootState }) });
    return next(enhancedAction);
    // eslint-disable-next-line @typescript-eslint/ban-types
}; }; });
export var middleWares = [
    hondaRestApiMiddleware,
    inventoryApiMiddleware,
    dealerApiMiddleware,
    publicationsApiMiddleware,
    layoutServiceApiMiddleware,
    rootStateMiddleware,
];
export var getStore = function () {
    var globalStore = configureStore === null || configureStore === void 0 ? void 0 : configureStore({
        reducer: rootReducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                serializableCheck: false,
            }).concat(middleWares);
        },
    });
    return globalStore;
};
export var store = getStore();
